import { css } from 'styled-system/css';

export const promotionAsideStyle = {
	promotionAside: css({
		base: {
			display: 'none',
			lgx: {
				position: 'relative',
				overflowY: 'auto',
				display: 'flex',
				flexDirection: 'column',
				bottom: 0,
				zIndex: 2,
				marginBottom: '0',    
				w: 'var(--promotion-chatroom-width)',
				height: 'auto',
				borderRadius: '6px',
			},

			'& .tab-switch': {
				top: '0px'
			},

			'& .footer': {
				pr: 'unset'
			}
		}
	}),
}